export default __webpack_public_path__ + "static/bspJxVXE-302d5072734257f60ded73053eaa9f82.svg";